module.exports = __webpack_public_path__ + "static/media/insideBlind.963da867.jpg";